<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">{{'NUMPAD' | translation}}</h5>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="close($event)">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  @if (numpad) {
    <div #body class="modal-body" style="min-height: 300px;">
      <div class="container">
        <div class="row g-1">
          <!--================-->
          <div class="col-12">
            <input class="form-control text-end border-primary" readonly [(ngModel)]="numpad.value">
          </div>
          <!--================-->
          <div class="col-4">
            <button class="btn btn-primary btn-block" (click)="number(7)">
              7
            </button>
          </div>
          <div class="col-4">
            <button class="btn btn-primary btn-block" (click)="number(8)">
              8
            </button>
          </div>
          <div class="col-4">
            <button class="btn btn-primary btn-block" (click)="number(9)">
              9
            </button>
          </div>
          <!--================-->
          <div class="col-4">
            <button class="btn btn-primary btn-block" (click)="number(4)">
              4
            </button>
          </div>
          <div class="col-4">
            <button class="btn btn-primary btn-block" (click)="number(5)">
              5
            </button>
          </div>
          <div class="col-4">
            <button class="btn btn-primary btn-block" (click)="number(6)">
              6
            </button>
          </div>
          <!--================-->
          <div class="col-4">
            <button class="btn btn-primary btn-block" (click)="number(1)">
              1
            </button>
          </div>
          <div class="col-4">
            <button class="btn btn-primary btn-block" (click)="number(2)">
              2
            </button>
          </div>
          <div class="col-4">
            <button class="btn btn-primary btn-block" (click)="number(3)">
              3
            </button>
          </div>
          <!--================-->
          <div class="col-4">
            <button class="btn btn-primary btn-block" (click)="toggleNegative()">
              +/-
            </button>
          </div>
          <div class="col-4">
            <button class="btn btn-primary btn-block" (click)="number(0)">
              0
            </button>
          </div>
          @if (numpad.decimals) {
            <div class="col-4">
              <button class="btn btn-primary btn-block" (click)="comma(localeService.decimalSeperator)">
                {{localeService.decimalSeperator}}
              </button>
            </div>
          }
          <!--================-->
          @if (numpad.decimals === 2) {
            <div class="col-4">
              <button class="btn btn-primary btn-block" (click)="comma(localeService.decimalSeperator + '25')">
                {{localeService.decimalSeperator}}25
              </button>
            </div>
          }
          @if (numpad.decimals === 2) {
            <div class="col-4">
              <button class="btn btn-primary btn-block" (click)="comma(localeService.decimalSeperator + '50')">
                {{localeService.decimalSeperator}}50
              </button>
            </div>
          }
          @if (numpad.decimals === 2) {
            <div class="col-4">
              <button class="btn btn-primary btn-block" (click)="comma(localeService.decimalSeperator + '75')">
                {{localeService.decimalSeperator}}75
              </button>
            </div>
          }
          <!--================-->
          <div class="col-6">
            <button class="btn btn-warning btn-block" (click)="delete()">
              C
            </button>
          </div>
          <div class="col-6">
            <button class="btn btn-success btn-block" (click)="ok($event)">
              {{'OK' | translation}}
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</div>
